import {AgendaSidebarCalendar} from '@/features/agenda/components/agenda-sidebar-calendar/AgendaSidebarCalendar'
import {AgendaSidebarSearch} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearch'
import {AgendaSidebarTeamCard} from '@/features/agenda/components/agenda-sidebar-team-card/AgendaSidebarTeamCard'
import {AgendaSubjectSelection} from '@/features/agenda/components/agenda-subject-selection/AgendaSubjectSelection'
import {AgendaSidebarViews} from '@/features/agenda/components/agenda-sidebar-views/AgendaSidebarViews'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaHolidaysCheckbox} from '@/features/agenda/components/agenda-holidays-checkbox/AgendaHolidaysCheckbox'
import {AgendaDomiciliaryCheckbox} from '@/features/agenda/components/agenda-domicliary-checkbox/AgendaDomiciliaryCheckbox'

export const AgendaUserSidebar = () => {
    return (
        <Flexbox direction="column" gap={3} fullWidth>
            <AgendaSidebarCalendar />
            <AgendaDomiciliaryCheckbox />
            <AgendaHolidaysCheckbox />
            <AgendaSidebarSearch searchTargets={['team', 'users']} />
            <AgendaSubjectSelection target="users" />
            <AgendaSidebarTeamCard />
            <AgendaSidebarViews />
        </Flexbox>
    )
}
